module.exports = __webpack_public_path__ + "static/media/38d96cff-e8b1-4b5e-80d5-8c9f813ce0a9.98a84980.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/38d96cff-e8b1-4b5e-80d5-8c9f813ce0a9.jpg
// module id = 813
// module chunks = 0